import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { GlobalResponse } from '../models';
import { CommonService } from '../common-service.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Constants } from '../constants';

@Component({
  selector: 'app-payment-dialog',
  templateUrl: './payment-dialog.component.html',
  styleUrls: ['./payment-dialog.component.css']
})
export class PaymentDialogComponent implements OnInit {
  payment = Constants.PAYMENT_CASH;
  paymentAmount: number;
  public grandTotal: number;
  public clinicId: string;
  public invoiceId: string;
  public doctorId: string;
  public navigateURL: string;
  pendingAmount: number;
  disableConfirmButton = false;

  constructor(
    public dialogRef: MatDialogRef<PaymentDialogComponent>,
    private commonService: CommonService,
    private loadingBar: LoadingBarService,
    private toastr: ToastrService,
    private router: Router
  ) { }

  ngOnInit() {
    this.paymentAmount = this.grandTotal;
    this.pendingAmount = 0;
  }

  changeAmount(type: string) {
    if (type === 'payment') {
      if (Number(this.paymentAmount) === 0) {
        this.disableConfirmButton = true;
      } else {
        this.disableConfirmButton = false;
        if (Number(this.paymentAmount) > this.grandTotal) {
          this.paymentAmount = this.grandTotal;
          this.pendingAmount = 0;
        } else {
          this.pendingAmount = this.grandTotal - Number(this.paymentAmount);
        }
      }
    }
  }

  confirmPayment = () => {
    // if (this.payment) {
    //   if (this.paymentAmount || this.paymentAmount >= 0) {
    //     this.loadingBar.start();
    //     let req_obj = {};
    //     req_obj = {
    //       invoiceId: this.invoiceId,
    //       paymentMethod: this.payment,
    //       amount: this.paymentAmount
    //     };
    //     this.commonService.updateTodayCheckupPayment(req_obj).subscribe(
    //       (res: GlobalResponse) => {
    //         // console.log(res);
    //         this.loadingBar.complete();
    //         this.toastr.success(Constants.LABEL_SUCCESS, Constants.SUCCESS_PAYMENT_DONE);
    //         this.dialogRef.close(true);
    //         if (this.navigateURL && this.navigateURL.length > 1) {
    //           setTimeout(() => {
    //             this.router.navigate([this.navigateURL]);
    //           }, 500);
    //         }
    //       },
    //       (error) => {
    //         this.loadingBar.complete();
    //         this.dialogRef.close(true);
    //         this.toastr.error(Constants.LABEL_ERROR, error.message);
    //       }
    //     );
    //   } else {
    //     this.toastr.error(Constants.LABEL_ERROR, Constants.ERROR_CHOOSE_PAYMENT_AMOUNT);
    //   }
    // } else {
    //   this.toastr.error(Constants.LABEL_ERROR, Constants.ERROR_CHOOSE_PAYMENT_AMOUNT);
    // }
  }

}
